export const Toggle = ({ checked, onClick }: { checked: boolean; onClick: () => void }) => (
  <button
    type="button"
    onClick={onClick}
    className={`relative h-6 w-11 shrink-0 rounded-full border transition-colors duration-200 cursor-pointer ${
      checked
        ? 'border-transparent bg-linear-to-br from-brand-teal to-brand-blue'
        : 'border-white/12 bg-white/10'
    }`}
  >
    <span
      className={`absolute top-0.5 left-0.5 h-[18px] w-[18px] rounded-full bg-white shadow-[0_1px_4px_rgba(0,0,0,0.3)] transition-transform duration-200 ${
        checked ? 'translate-x-5' : 'translate-x-0'
      }`}
    />
  </button>
);
